import "./style.css";
import Swiper from "swiper";

class PCVideoGrids extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initVideoPopup();
    this.initSwiper();
  }

  initVideoPopup() {
    const playButtons = this.querySelectorAll(".pc-video-grids__play-button");
    playButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        const videoUrl = event.currentTarget.getAttribute("data-video-url");
        this.openVideoPopup(videoUrl);
      });
    });
  }

  openVideoPopup(videoUrl) {
    const popup = document.createElement("div");
    popup.classList.add("video-popup");
    popup.innerHTML = `
      <div class="video-popup__overlay"></div>
      <div class="video-popup__content">
        <button class="video-popup__close">×</button>
        <video src="${videoUrl}" controls autoplay class="video-popup__video"></video>
      </div>
    `;
    document.body.appendChild(popup);

    const closeButton = popup.querySelector(".video-popup__close");
    const overlay = popup.querySelector(".video-popup__overlay");

    const closePopup = () => {
      document.body.removeChild(popup);
    };

    closeButton.addEventListener("click", closePopup);
    overlay.addEventListener("click", closePopup);
  }

  initSwiper() {
    const swiperContainer = this.querySelector(".pc-video-grids__carousel");
    let desktop_per_view = this.querySelectorAll(".swiper-slide").length;
    console.log(desktop_per_view);
    if (swiperContainer) {
      new Swiper(swiperContainer, {
        slidesPerView: 2.3,
        spaceBetween: 34,
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 16,
          },
          1024: {
            slidesPerView: desktop_per_view,
            spaceBetween: 28,
          },
        },
      });
    }
  }
}

customElements.define("pc-video-grids", PCVideoGrids);
